
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiredc87"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiredc87"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("c1bOu", function(module, exports) {

$parcel$export(module.exports, "register", () => $8bfebded0011ab7d$export$6503ec6e8aabbaf, (v) => $8bfebded0011ab7d$export$6503ec6e8aabbaf = v);
var $8bfebded0011ab7d$export$6503ec6e8aabbaf;
var $8bfebded0011ab7d$export$f7ad0328861e2f03;
"use strict";
var $8bfebded0011ab7d$var$mapping = new Map();
function $8bfebded0011ab7d$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$8bfebded0011ab7d$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $8bfebded0011ab7d$var$resolve(id) {
    var resolved = $8bfebded0011ab7d$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$8bfebded0011ab7d$export$6503ec6e8aabbaf = $8bfebded0011ab7d$var$register;
$8bfebded0011ab7d$export$f7ad0328861e2f03 = $8bfebded0011ab7d$var$resolve;

});

var $c3f9ef799c74b805$exports = {};

(parcelRequire("c1bOu")).register(new URL("", import.meta.url).toString(), JSON.parse('["bXkwM","index.4a2b78a0.js","IA7EQ","zusam_logo.1eebfd28.svg"]'));


//# sourceMappingURL=index.runtime.9940b38b.js.map
